<template>
  <lists :suppress="0" :external-type="integrationsTypes.sportradar" />
</template>

<script>
import Lists from '@/modules/audiences/pages/BaseLists'
import { integrationsTypes } from '@/modules/integrations/enum/IntegrationsEnum'

export default {
  data() {
    return { integrationsTypes }
  },
  components: { Lists }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SportradarLists.vue